import React, { useEffect, useState } from "react";

/**
 * 🔐 ADMIN TOGGLE
 * Set this to true ONLY in dashboard/admin view
 * Keep it false for public users (AdSense safe)
 */
const IS_ADMIN = false;

const VerticalSponsoredBanner = () => {
    const [clicks, setClicks] = useState(0);

    // Load stored clicks
    useEffect(() => {
        const stored = localStorage.getItem("wifeRecipeBannerClicks");
        if (stored) setClicks(Number(stored));
    }, []);

    // Unique user click handler
    const handleClick = () => {
        const alreadyClicked = localStorage.getItem("wifeRecipeUserClicked");

        // Prevent multiple counts from same user
        if (alreadyClicked) return;

        const newCount = clicks + 1;
        setClicks(newCount);

        localStorage.setItem("wifeRecipeBannerClicks", newCount);
        localStorage.setItem("wifeRecipeUserClicked", "true");
    };

    return (
        <a
            href="https://www.youtube.com/@WifeRecipeBook"
            target="_blank"
            rel="noopener noreferrer nofollow sponsored"
            onClick={handleClick}
            style={{ textDecoration: "none", display: "block" }}
        >
            <div style={styles.card}>
                {/* 🔵 Click Counter (ADMIN ONLY) */}
                {IS_ADMIN && (
                    <div style={styles.counterBadge}>
                        {clicks}
                    </div>
                )}

                {/* Sponsored Label */}
                <div style={styles.sponsored}>SPONSORED</div>

                {/* Logo */}
                <div style={styles.logoWrap}>
                    <img
                        src="/wife-recipe-book.jpeg"
                        alt="Wife’s Recipe Book"
                        style={styles.logo}
                        loading="lazy"
                    />
                </div>

                {/* Title */}
                <h3 style={styles.title}>Wife’s Recipe Book</h3>

                {/* Channel Info */}
                <div style={styles.channelRow}>
                    <span style={styles.youtubeIcon}>▶</span>
                    <span style={styles.channelText}>YouTube Channel</span>
                </div>

                <div style={styles.handle}>@WifeRecipeBook</div>

                {/* Description */}
                <p style={styles.desc}>
                    Delicious homemade Indian recipes 🍲
                    <br />
                    Simple • Street-style • Daily kitchen tips
                </p>

                {/* CTA */}
                <button style={styles.button}>
                    Subscribe Now
                </button>
            </div>
        </a>
    );
};

const styles = {
    card: {
        width: "100%",
        maxWidth: "360px",
        margin: "0 auto",
        padding: "26px",
        borderRadius: "26px",
        background:
            "linear-gradient(180deg, #fff7e6 0%, #ffe0b2 60%, #ffd180 100%)",
        boxShadow: "0 12px 28px rgba(0,0,0,0.25)",
        textAlign: "center",
        fontFamily: "Inter, Arial, sans-serif",
        position: "relative",
    },

    /* 🔵 Admin Counter */
    counterBadge: {
        position: "absolute",
        top: "10px",
        left: "10px",
        width: "28px",
        height: "28px",
        borderRadius: "50%",
        background: "linear-gradient(180deg, #4caf50, #2e7d32)",
        color: "#fff",
        fontSize: "12px",
        fontWeight: "700",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 10px rgba(0,0,0,0.35)",
    },

    sponsored: {
        position: "absolute",
        top: "14px",
        right: "16px",
        fontSize: "11px",
        fontWeight: "700",
        letterSpacing: "1px",
        color: "#8d6e63",
        background: "rgba(255,255,255,0.65)",
        padding: "4px 10px",
        borderRadius: "12px",
    },

    logoWrap: {
        display: "flex",
        justifyContent: "center",
        marginBottom: "18px",
        marginTop: "14px",
    },

    logo: {
        width: "120px",
        height: "120px",
        borderRadius: "50%",
        backgroundColor: "#fff",
        padding: "10px",
        boxShadow: "0 12px 30px rgba(0,0,0,0.35)",
        transform: "scale(1.25)",
        objectFit: "contain",
    },

    title: {
        fontSize: "22px",
        color: "#3e2723",
        marginBottom: "6px",
        fontWeight: "700",
    },

    channelRow: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "6px",
        marginBottom: "4px",
    },

    youtubeIcon: {
        color: "#ff0000",
        fontSize: "14px",
        fontWeight: "900",
    },

    channelText: {
        fontSize: "13px",
        fontWeight: "600",
        color: "#d84315",
    },

    handle: {
        fontSize: "14px",
        color: "#5d4037",
        marginBottom: "14px",
    },

    desc: {
        fontSize: "15px",
        lineHeight: "1.6",
        color: "#4e342e",
        marginBottom: "22px",
    },

    button: {
        background:
            "linear-gradient(180deg, #ff3d00 0%, #c62828 100%)",
        color: "#fff",
        border: "none",
        padding: "14px 38px",
        borderRadius: "36px",
        fontSize: "16px",
        fontWeight: "700",
        cursor: "pointer",
        boxShadow: "0 8px 20px rgba(198,40,40,0.45)",
    },
};

export default VerticalSponsoredBanner;
